import PropTypes from "prop-types";
import { ButtonSize } from "../../classes/enums/ButtonEnum";
import IconsEnum from "../../classes/enums/IconsEnum";
import IconButton from "../iconButton/IconButton";
import RangeSlider from "../rangeSlider/RangeSlider";
import { TooltipOrientation } from "../tooltip/Tooltip";
import "./LabeledSlider.css";

export const LABELED_SLIDER_TYPES = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
};

const LabeledSlider = ({
  label,
  min,
  max,
  value,
  onChange,
  className = "",
  type = LABELED_SLIDER_TYPES.VERTICAL,
  disabled = false,
  tooltip = null,
  markers = [],
  debounceMs = 0,
}) => {
  return (
    <div
      className={`LabeledSlider-container ${
        type === LABELED_SLIDER_TYPES.VERTICAL
          ? LABELED_SLIDER_TYPES.VERTICAL
          : LABELED_SLIDER_TYPES.HORIZONTAL
      }`}
    >
      {label !== "" && (
        <label
          className={`LabeledSlider-label App-text-large ${
            disabled ? "disabled" : ""
          }`}
        >
          {label}
          {tooltip && (
            <div className="LabeledSlider-tooltip App-text-small">
              <IconButton
                icon={IconsEnum.INFO}
                title={tooltip}
                onClick={e => e.stopPropagation()}
                isCircle
                size={ButtonSize.MICRO}
                isLightBlue={false}
                tooltipOrientation={TooltipOrientation.Right}
              />
            </div>
          )}
        </label>
      )}

      <div className="Slider-container">
        <RangeSlider
          min={min}
          max={max}
          rangeValue={value ?? 0}
          onRangeValueChanged={onChange}
          className={`LabeledSlider-slider ${className} `}
          disabled={disabled}
          markers={markers}
          debounceMs={debounceMs}
        />
      </div>
    </div>
  );
};

LabeledSlider.propTypes = {
  label: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  debounceMs: PropTypes.number,
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string,
    })
  ),
};

export default LabeledSlider;
